<header class="long-header">
  <div
    class="flex-container"
    fxLayout="column"
    fxLayout.gt-sm="row"
  >
    <div
      class="img-wrapper"
      style="background-image: url('/assets/images/services/header_background.jpg')"
      fxFlex="100%"
      fxFlex.gt-sm="50%">
    </div>
    <div
      fxFlex="100%"
      fxFlex.gt-sm="50%"
      class="header-content-wrapper"
    >
      <ng-template
        [ngIf]="reasons[0]"
      >
        <div
          fxLayout="column"
          fxLayoutAlign="center center"
          fxLayoutAlign.gt-sm="center start"
          >
          <h2 class="center">
            De ce sa lucrezi cu noi
          </h2>
          <div class="header-content">
            <p>
              {{ reasons[0].description }}
            </p>
          </div>
          <a
            mat-raised-button
            color="transparent"
            routerLink="/despre-noi"
          >
            Afla mai multe
          </a>
        </div>
      </ng-template>
    </div>
  </div>
</header>

<section
  class="container-fluid services"
  [style.minHeight.px]="pageHeight"
>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="services-title-container"
  >
    <h2>
      Serviciile
      <span class="after-title">
        {{ agencyService.agency.name }}
      </span>
    </h2>
  </div>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center"
    class="services-list"
  >
    <div
      fxLayout="row wrap"
      fxLayoutAlign="center center"
      class="aw-item background-behind"
      [ngStyle]="{'background-image': 'url(' + service.image.width_320_url +')'}"
      *ngFor="let service of services"
    >
      <div
        fxLayout="column"
        fxLayoutAlign="space-between center"
        class="aw-item"
        (click)="openServiceModal(service);"
      >
        <div class="center">
          <div
            class="my-image"
            [ngStyle]="{'background-image': 'url(' + service.image.width_320_url +')'}"
          >
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="services-items-title-container"
          >
            <h4>
              {{ service.name }}
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/services/services.component.html